import type React from 'react';
import { CommonButton } from '@shared/ui';
import { ModalError } from '@src/modules/Authentication/frames/modal-error';
import { AuthForm } from '../../AuthFrom';
import ButtonLink from '../../ButtonLink';
import CustomInput from '../../CustomInput';
import { useLogin } from './model';
import * as st from './styles.module.scss';

interface Props {
  openRestore: () => void;
}

export const Login: React.FC<Props> = ({ openRestore }) => {
  const login = useLogin();
  const errorMessage = login.errors?.root?.message;
  return (
    <>
      <AuthForm onSubmit={login.handleSubmit((data) => login.login(data))}>
        <div className={st.block_up}>
          <CustomInput
            onChange={login.clearErrors}
            tabindex={0}
            type="phonenumber"
            label="Телефон"
            name="phonenumber"
            control={login.control}
            error={login.errors?.phonenumber}
            disabled={login.isLoading}
            variant="outline"
          />

          <CustomInput
            onChange={login.clearErrors}
            tabindex={0}
            type="password"
            label="Пароль"
            name="password"
            control={login.control}
            error={login.errors?.password}
            disabled={login.isLoading}
            showPassword={login.showPassword}
            setValue={() => {
              login.setShowPassword(!login.showPassword);
            }}
          />
          <ButtonLink disabled={login.isLoading} handler={openRestore}>
            Забыли пароль?
          </ButtonLink>
        </div>
        {errorMessage ? (
          <ModalError error={errorMessage} />
        ) : (
          <CommonButton type="submit" disabled={login.isLoading || !login.isFieldsNotEmpty}>
            Войти
          </CommonButton>
        )}
      </AuthForm>
    </>
  );
};
